<template>
  <el-row class="core_one_wrap">
    <el-col class="one_left">
      <img src="@/assets/img/coreCompetence/cs-4.jpg" alt="">
    </el-col>
    <el-col class="one_right">
      <div class="left_tit">
        职业就业
      </div>
      <ul class="left_desc">
        职业规划，根据中国职业规划师协会的定义，是对职业生涯乃至人生进行持续的系统性计划的过程，包括职业定位、目标设定和通道设计三大核心要素。
      </ul>

    </el-col>

  </el-row>
</template>

<script>
export default {
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.core_one_wrap {
  height: 440px;
  display: flex;
  justify-content: center;
  text-align: left;
  margin-bottom: 30px;
  background: #282828;
  padding-top: 60px;
  padding-bottom: 50px;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
  .one_right {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .left_tit {
      font-size: 30px;
      font-weight: bold;
      color: #EB6629;
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }

    .left_desc {
      color: #fff;

      font-size: 18px;
      line-height: 30PX;
      li {
        line-height: 25PX;
      }
      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    .left_card {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 25px;
      margin-right: 80px;
      @media screen and (max-width: 768px) {
        margin: 0;
      }
      .card_item {
        box-sizing: border-box;
        width: 30%;
        height: 50px;
        background: #fff;
        box-shadow: 0 -0.0625rem 0.4375rem 0 silver,
        0 0 0.75rem 0 rgb(0 0 0 / 10%);
        display: flex;
        align-items: center;
        color: #0991d3;
        padding: 0 20px;
        cursor: pointer;
        @media screen and (max-width: 768px) {
          height: 50PX;
        }
        i{
          font-size: 1.3rem;
        }
        &:nth-child(n + 4) {
          margin-top: 30px;
          @media screen and (max-width: 768px) {
            margin-top: 16PX;
          }
        }
        &:hover .item_txt {
          letter-spacing: 4px;
        }
        .item_txt {
          width: 100%;
          font-weight: bold;
          font-size: 17px;
          margin-left: 10px;
          transition: all 1s;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }
  }

  .one_left {
    width: 25%;
    height: 100%;
    margin-right: 5%;
    @media screen and (max-width: 768px) {
      width: 70%;
    }
    img{
      width: 100%;
    }
  }
}
</style>